import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createMembershipData = createAsyncThunk(
   "/membership/createMembership",
   async (membershipData, { rejectWithValue }) => {
    try {
        const response = await axios.post("/membership/createMembership",
            membershipData,
            {
              headers: {
                "Content-Type": "application/json",
                token: membershipData.token
              },
            }

        );
        return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
   }
);
export const getAllMembership =  createAsyncThunk(
    "membership/getAllMembership",
    async (membershipData, { rejectWithValue }) => {
        try {
            const response = await axios.post("/membership/getAllMembership",
              membershipData,
              {
                headers: {
                  "Content-Type": "application/json",
                  token: membershipData.token
                },
              }
            );
            return response.data;
          } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
          }  
    }
);
export const updateMembershipSlice = createAsyncThunk(
    "membership/updateMembership",
    async (membershipData, { rejectWithValue }) => {
      try {
        const response = await axios.put("/membership/updateMembership",
          membershipData,
          {
            headers: {
              "Content-Type": "application/json",
              token: membershipData.token
            },
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message)
      }
    }
  );

  export const getMembershipIdSlice = createAsyncThunk(
    "membership/getMembershipById",
    async (membershipData, { rejectWithValue }) => {
      try {
        const response = await axios.post("/membership/getMembershipById",
          membershipData,
          {
            headers: {
              "Content-Type": "application/json",
              token: membershipData.token
            },
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message)
      }
    }
  );
  export const deleteMembershipSlice = createAsyncThunk(
    "membership/deleteMembership",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axios.put("/membership/deleteMembership",
          data,
          {
            headers: {
              "Content-Type": "application/json",
              token: data.token
            },
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message)
      }
    }
  );

  const MembershipDetails = createSlice({
    name: "membershipData",
    initialState: {
        loading: false,
        membershipSuccessMessage: null,
        membershipErrorMessage: null,
        membershipUpdateSuccessMessage: null,
        membershipUpdateErrorMessage: null,
        membershipDeleteSuccessMessage: null,
        membershipDeleteErrorMessage: null,
        memberships: [],
        membershipData: null,
      },
      reducers: {
        resetMessage: (state) => {
          state.membershipSuccessMessage = null;
          state.membershipErrorMessage = null;
        },
        resetUpdateMessages: (state) => {
          state.membershipUpdateSuccessMessage = null;
          state.membershipUpdateErrorMessage = null;
        },
        resetDeleteMessages: (state) => {
          state.membershipDeleteSuccessMessage = null;
          state.membershipDeleteErrorMessage = null;
        },
        resetMembershipData: (state) => {
          state.memberships = [];
          state.membershipData = null;
        },
      },
        extraReducers: (builder) => {
          builder
            .addCase(createMembershipData.pending, (state) => {
              state.loading = true;
              state.membershipSuccessMessage = null;
              state.membershipErrorMessage = null;
            })
            .addCase(createMembershipData.fulfilled, (state, action) => {
              state.loading = false;
              if (action.payload.success === true) {
                state.membershipSuccessMessage = action.payload.result.message;
              } else {
                state.membershipErrorMessage = action.payload.result.message;
              }
            })
            .addCase(createMembershipData.rejected, (state, action) => {
              state.loading = false;
              state.membershipErrorMessage = action.payload;
            })
            .addCase(getAllMembership.pending, (state, action) => {
              state.loading = true;
            })
.addCase(getAllMembership.fulfilled, (state, action) => {
  state.loading = false;
  if (!action.payload.success) {
    state.memberships = [];
    state.totalCount = 0;
    state.totalPages = 1;
    state.currentPage = 1;
    state.hasMore = false;
    state.searchMessage =
      action.payload.result?.message || "No data found";
    return;
  }
  const result = action.payload.result;
  state.memberships = result.list || [];
  state.currentPage = Number(result.currentPage) || 1;
  state.totalPages = Number(result.totalPages) || 1;
  state.totalCount = Number(result.totalRecords) || 0;
  state.hasMore = result.hasMore ?? false;
  state.searchMessage = null;
})

            .addCase(getAllMembership.rejected, (state, action) => {
              state.loading = false;
            })
            .addCase(updateMembershipSlice.pending, (state) => {
              state.loading = true;
              state.membershipUpdateSuccessMessage = null;
              state.membershipUpdateErrorMessage = null;
            })
            .addCase(updateMembershipSlice.fulfilled, (state, action) => {
              state.loading = false;
              if (action.payload.success === false) {
                state.membershipUpdateErrorMessage = action.payload.result.message;
              } else {
                state.membershipUpdateSuccessMessage = action.payload.result.message;
              }
            })
            .addCase(updateMembershipSlice.rejected, (state, action) => {
              state.loading = false;
              state.membershipUpdateErrorMessage = action.payload.result.message;
            })
            .addCase(getMembershipIdSlice.pending, (state) => {
              state.loading = true;
              state.error = null;
            })
            .addCase(getMembershipIdSlice.fulfilled, (state, action) => {
              state.loading = false;
              state.membershipData = action.payload.result.list;
            })
            .addCase(getMembershipIdSlice.rejected, (state, action) => {
              state.loading = false;
              state.error = action.payload.result.message;
            })
            .addCase(deleteMembershipSlice.pending, (state) => {
              state.loading = true;
              state.membershipDeleteSuccessMessage = null;
              state.membershipDeleteErrorMessage = null;
            })
            .addCase(deleteMembershipSlice.fulfilled, (state, action) => {
              state.loading = false;
              if (action.payload.success === false) {
                state.membershipDeleteErrorMessage = action.payload.result.message;
              } else {
                state.membershipDeleteSuccessMessage = action.payload.result.message;
              }
            })
            .addCase(deleteMembershipSlice.rejected, (state, action) => {
              state.loading = false;
              state.membershipDeleteErrorMessage = action.payload.result.message;
            });
        },
  });
  export const {
    resetMessage,
    resetUpdateMessages,
    resetDeleteMessages,
    resetMembershipData,
  } = MembershipDetails.actions;
  export default MembershipDetails.reducer;
